// extracted by mini-css-extract-plugin
export default {"link":"JK-z","disabled":"KK-z"};